import React from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { Instrument } from "apis/models/commons/instrument";
import SelectPredefinedTable from "taskpane/components/ExcelAddIn/SelectPredefinedTable";
import { styles } from "./styles";

const useStyles = makeStyles(() => createStyles(styles));

type Props = {
  onClickMarket: (instrument: Instrument[], tableName: any) => void;
  setShowSpinner: (showSpinner: boolean) => void;
  handleCallback: (childData: any) => void;
  onCutAddTable: () => void;
  onCopyAddTable: () => void;
  onPasteAddTable: () => void;
  cardPaste:Boolean;
  cardTableEnabled: Boolean;

};
const Market = ({
  onClickMarket,
  setShowSpinner,
  handleCallback,
  onCutAddTable,
  onCopyAddTable,
  onPasteAddTable,
  cardPaste,
  cardTableEnabled,
}: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Grid container>
        <Grid item xs={12} sm={12}>
          <SelectPredefinedTable
            setShowSpinner={setShowSpinner}
            onClickMarket={onClickMarket}
            handleCallback={handleCallback}
            onCutAddTable={onCutAddTable}
            onCopyAddTable={onCopyAddTable}
            onPasteAddTable={onPasteAddTable}
            cardPaste={cardPaste}
            cardTableEnabled={cardTableEnabled}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default Market;
